import createImageUrlBuilder from '@sanity/image-url'

import { dataset, projectId } from '@/sanity/lib/env'
import { SanityAsset } from '@sanity/image-url/lib/types/types'

const imageBuilder = createImageUrlBuilder({
	projectId: projectId || '',
	dataset: dataset || ''
})

export const urlForImage = (source: SanityAsset) => {
	// Ensure that source image contains a valid reference
	if (!source?.asset) return undefined

	if (source?.asset?.url?.endsWith('.gif')) {
		return imageBuilder?.image(source)
	}

	return imageBuilder?.image(source).auto('format').fit('max').quality(100)
}

export function urlForOpenGraphImage(image: SanityAsset) {
	return urlForImage(image)?.width(1200).height(630).fit('crop').quality(100).url()
}
